import { Component } from '@angular/core';
import { ClienBaseComponent } from '../../client-partner/client-base/client-base.component';
 

@Component({
  selector: 'employer-base',
  templateUrl: './employer-base.component.html'
})
export class EmployerBaseComponent extends ClienBaseComponent {

}
